import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchDyeingDC } from '../dyeingDC/dyeingDC.actions';
import { DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE } from '../dyeingDC/dyeingDC.actionsType';
import {
    CREATE_DYEING_DC_DETAILS_FAILURE,
    CREATE_DYEING_DC_DETAILS_REQUEST,
    CREATE_DYEING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_DYEING_DC_DETAILS,
    DELETE_DYEING_DC_DETAILS_FAILURE,
    DELETE_DYEING_DC_DETAILS_REQUEST,
    DELETE_DYEING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS,
    FETCH_DYEING_DC_DETAILS_FAILURE,
    FETCH_DYEING_DC_DETAILS_REQUEST,
    FETCH_DYEING_DC_DETAILS_SUCCESS,
    DYEING_DC_DETAILS_USERFORM_RESET,
    UPDATE_DYEING_DC_DETAILS_FAILURE,
    UPDATE_DYEING_DC_DETAILS_REQUEST,
    UPDATE_DYEING_DC_DETAILS_SUCCESS,
    FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE,
    FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE,
    FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_REQUEST,
    FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_SUCCESS,
    FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_FAILURE,
    FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_SUCCESS,
    FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_FAILURE,
    FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_REQUEST
} from './dyeingDCDetails.actionsType';
import moment from 'moment';

// FETCH PROPERTY MASTER
export let fetchDyeingDCDetailsById = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCDetailsGET_BY_ID}/${id}`,
        responseTypeRequest: FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchDyeingDCDetails = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCDetailsGET}`,
        responseTypeRequest: FETCH_DYEING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_DETAILS_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createDyeingDCDetailsUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_DYEING_DC_DETAILS, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createDyeingDCDetails = (formData, modalClose, isStatus, parentId, headerUserForm, isDirectDetails, styleID, status, programId, salesOrder, code, showPrevious) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        FldPreviousDCPO: formData.FldPreviousDCPO,
        FldFKProgram: parseInt(formData.FldFKProgram),
        FldProgram: formData.FldProgram,
        FldInwardDia: formData.FldInwardDia,
        FldFKInwardDia: parseInt(formData.FldFKInwardDia),
        fldFKDCNo: parseInt(formData.fldFKDCNo),
        fldFKFabricOrKnittingPO: parseInt(formData.fldFKFabricOrKnittingPO),
        fldFabricOrKnittingPO: formData?.fldFabricOrKnittingPO,
        fldFKStyle: parseInt(formData.fldFKStyle),
        // fldFKMainstyle: parseInt(formData.fldFKMainstyle),
        fldStyleNumber: formData?.fldStyleNumber,
        fldFKSaleOrder: formData?.fldFKSaleOrder,
        fldSalesOrderNo: formData?.fldSalesOrderNo,
        fldFKColour: parseInt(formData.fldFKColour),
        fldColour: formData?.fldColour,
        fldFKColourShade: parseInt(formData.fldFKColourShade),
        fldColourShade: formData?.fldColourShade,
        fldFKFabric: parseInt(formData.fldFKFabric),
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFabricGroup: formData?.fldFabricGroup,
        fldFabric: formData?.tblFabricname,
        tblFabricname: formData?.tblFabricname,
        fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldFabricMaster: formData?.fldFabricMaster,
        fldFKYarnCounts: parseInt(formData.fldFKYarnCounts),
        fldYarnCounts: formData?.fldYarnCounts,
        FldPreProgramCode: formData?.FldPreProgramCode,
        fldRate: Number(formData?.fldRate),
        fldQuantity: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        // fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        //  fldDeletedDt: today.toISOString(),
        fldFKStatus: 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKDia: parseInt(formData?.fldFKDia),
        fldDia: formData?.fldDia,
        fldRequiredDia: formData?.fldRequiredDia,
        fldRequiredGSM: formData?.fldFKGSM || '',
        fldFKGSM: 0,
        fldGSM: formData.fldFKGSM || '',
        fldLoopLength: '0',
        fldFKRatePerKG: formData.fldFKRatePerKG ? Number(formData.fldFKRatePerKG) : 0,
        fldNoofRolls: '0',
        fldFKNoofRolls: Number(formData?.fldFKNoofRolls),
        fldFKWeightinKG: Number(formData.fldQuantity),
        fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: formData?.fldBalanceQuantity ? Number(formData?.fldBalanceQuantity) : 0,
        fldIsCora: formData?.fldIsCora,
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.dyeingDCDetailsPOST}?FldInwardId=${formData?.inwardId?.toString()}&ProgramId=${formData?.ProgramMappingId || formData?.FldFKProgram}`,
        responseTypeRequest: CREATE_DYEING_DC_DETAILS_REQUEST,
        responseTypeSuccess: CREATE_DYEING_DC_DETAILS_SUCCESS,
        responseTypeFailure: CREATE_DYEING_DC_DETAILS_FAILURE,
        // resetFormData: isStatus ? DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE : DYEING_DC_DETAILS_USERFORM_RESET,
        resetFormData: DYEING_DC_DETAILS_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        singlApiArray: [isDirectDetails ? fetchDyeingDC(
            moment(headerUserForm.startDate).format('YYYY-MM-DD'),
            moment(headerUserForm.endDate).format('YYYY-MM-DD'),
            headerUserForm.unitId || 1) : fetchDyeingDCPreviousGetList(styleID, status, programId, salesOrder, code, showPrevious)],
        getAllData: fetchDyeingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleDyeingDCDetails = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingDCDetailsGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE,
        singlApiArray: []
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateDyeingDCDetails = (formData, id, parentId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        FldFKPreviousDCPO: parseInt(formData.FldFKPreviousDCPO),
        FldPreviousDCPO: formData.FldPreviousDCPO,
        FldFKProgram: parseInt(formData.FldFKProgram),
        FldInwardDia: formData.FldInwardDia,
        FldFKInwardDia: formData.FldFKInwardDia,
        FldProgram: formData.FldProgram,
        fldFKSaleOrder: formData?.fldFKSaleOrder,
        fldSalesOrderNo: formData?.fldSalesOrderNo,
        fldFKDCNo: parseInt(formData.fldFKDCNo),
        fldFabricOrKnittingPO: formData?.fldFabricOrKnittingPO,
        fldFKFabricOrKnittingPO: parseInt(formData.fldFKFabricOrKnittingPO),
        fldFKStyle: parseInt(formData.fldFKStyle),
        // fldFKMainstyle: parseInt(formData.fldFKMainstyle),
        fldStyleNumber: formData?.fldStyleNumber,
        fldFKColour: parseInt(formData.fldFKColour),
        fldColour: formData?.fldColour,
        fldFKColourShade: parseInt(formData.fldFKColourShade),
        fldColourShade: formData?.fldColourShade,
        fldFKFabric: parseInt(formData.fldFKFabric),
        fldFabric: formData?.tblFabricname,
        tblFabricname: formData?.tblFabricname,
        fldFKFabricGroup: parseInt(formData.fldFKFabricGroup),
        fldFabricGroup: formData?.fldFabricGroup,
        fldFKFabricMaster: parseInt(formData.fldFKFabricMaster),
        fldFabricMaster: formData?.fldFabricMaster,
        fldFKYarnCounts: parseInt(formData.fldFKYarnCounts),
        fldYarnCounts: formData?.fldYarnCounts,
        FldPreProgramCode: formData?.FldPreProgramCode,
        fldRate: Number(formData?.fldRate),
        fldQuantity: formData.fldQuantity ? Number(formData.fldQuantity) : 0,
        fldGrossValue: formData.fldGrossValue ? Number(formData.fldGrossValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldTaxableValue: formData.fldTaxableValue ? Number(formData.fldTaxableValue) : 0,
        fldIGSTPercentage: formData.fldIGSTPercentage ? Number(formData.fldIGSTPercentage) : 0,
        fldIGSTValue: formData.fldIGSTValue ? Number(formData.fldIGSTValue) : 0,
        fldSGSTPercentage: formData.fldSGSTPercentage ? Number(formData.fldSGSTPercentage) : 0,
        fldSGSTValue: formData.fldSGSTValue ? Number(formData.fldSGSTValue) : 0,
        fldCGSTPercentage: formData.fldCGSTPercentage ? Number(formData.fldCGSTPercentage) : 0,
        fldCGSTValue: formData.fldCGSTValue ? Number(formData.fldCGSTValue) : 0,
        fldGSTValue: formData.fldGSTValue ? Number(formData.fldGSTValue) : 0,
        fldTotalValue: formData.fldTotalValue ? Number(formData.fldTotalValue) : 0,
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData?.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: formData?.fldCreatedDt,
        fldModifiedBy: 11,
        //   fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        //   fldDeletedDt: today.toISOString(),
        fldFKStatus: formData?.fldFKStatus,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKDia: parseInt(formData?.fldFKDia),
        fldDia: formData?.fldDia,
        fldRequiredDia: formData.fldRequiredDia ? Number(formData.fldRequiredDia) : 0,
        fldRequiredGSM: formData?.fldFKGSM || '',
        fldFKGSM: 0,
        fldGSM: formData.fldFKGSM || '',
        fldLoopLength: '0',
        fldFKRatePerKG: formData.fldFKRatePerKG ? Number(formData.fldFKRatePerKG) : 0,
        fldNoofRolls: '0',
        fldFKNoofRolls: Number(formData?.fldFKNoofRolls),
        fldFKWeightinKG: Number(formData.fldQuantity),
        fldInwardQuantity: formData?.fldInwardQuantity ? Number(formData?.fldInwardQuantity) : 0,
        fldCancelQuantity: formData?.fldCancelQuantity ? Number(formData?.fldCancelQuantity) : 0,
        fldBalanceQuantity: formData?.fldBalanceQuantity ? Number(formData?.fldBalanceQuantity) : 0,
        fldIsCora: formData?.fldIsCora,
    });

    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.dyeingDCDetailsPATCH}/${id}`,
        responseTypeRequest: UPDATE_DYEING_DC_DETAILS_REQUEST,
        responseTypeSuccess: UPDATE_DYEING_DC_DETAILS_SUCCESS,
        responseTypeFailure: UPDATE_DYEING_DC_DETAILS_FAILURE,
        resetFormData: DYEING_DC_DETAILS_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchDyeingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteDyeingDCDetails = (id, parentId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.dyeingDCDetailsDELETE}/${id}`,
        responseTypeRequest: DELETE_DYEING_DC_DETAILS_REQUEST,
        responseTypeSuccess: DELETE_DYEING_DC_DETAILS_SUCCESS,
        responseTypeFailure: DELETE_DYEING_DC_DETAILS_FAILURE,
        modalClose: true,
        getAllData: fetchDyeingDCDetailsById(parentId)
    };
    return axiosCall(config);
};

export let fetchDyeingDCPreviousGetList = (style, value, fkDetailId, salesId, code, showPrevious) => {

    let currentUrl = showPrevious ? `${ConstantApi.knittingDcDetailsPreviousGetListGET}?FldFKStyleId=${style}&FldFKStyleDetailId=${fkDetailId}&FldFkProgramCode=DYD&IsUpdated=${value}&FldFKSaleOrder=${salesId}` : `${ConstantApi.dyeingDcDetailsGetListFabStockGET}?FldFKStyle=${style}&FldFKSalesOrder=${salesId}&FldProgramCode=${code}`


    let config = {
        method: 'get',
        url: currentUrl,
        responseTypeRequest: FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchDyeingDCReprocessPreviousGetList = (IsCost, SupplierId, styleId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.dyeingReprocessPrevListGET}?FldIsWithCost=${IsCost}&FldFKSupplierId=${SupplierId}&FldFKStyle=${styleId}`,
        responseTypeRequest: FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_FAILURE
    };
    return axiosCall(config);
};

export let fetchDyeingDCColorFrmStyle = (style, fldId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.knittingDcDetailsColorFrmStyleDyeingGET}?FldFKStyle=${style}&fldId=${fldId}`,
        responseTypeRequest: FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};

export let fetchDyeingDCRateFrmStyle = (style, fabGrp, yrnCnt, fab, dia, color, fldId) => {
    // console.log('color NGG', color)
    let config = {
        method: 'get',
        url: `${ConstantApi.knittingDcDetailsRateFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yrnCnt}&Fab=${fab}&Dia=${dia}&Colour=${color}&fldId=${fldId}`,
        responseTypeRequest: FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};
